import {
  ensureError,
  ensureHelp,
  ensureLabel,
  INPUT_BASE_CLASS,
  type FieldRenderContext,
  type FieldType,
} from './base.js';
import { validateLength, validateRequired } from '../validation.js';
import { withCustomMessage } from './text.js';

function ensureTextarea(ctx: FieldRenderContext): HTMLTextAreaElement {
  let ta = ctx.host.querySelector<HTMLTextAreaElement>(':scope > textarea');
  if (!ta) {
    ta = document.createElement('textarea');
    ta.className = INPUT_BASE_CLASS;
    ctx.host.insertBefore(ta, ctx.host.querySelector(':scope > .plp-field-error'));
  }
  ta.name = ctx.name;
  ta.required = ctx.required;
  if (ctx.placeholder !== undefined) ta.placeholder = ctx.placeholder;
  if (ctx.defaultValue !== undefined && !ta.value) ta.value = ctx.defaultValue;
  const rows = ctx.host.getAttribute('rows');
  ta.rows = rows ? parseInt(rows, 10) : 4;
  const max = ctx.host.getAttribute('maxlength');
  if (max) ta.maxLength = parseInt(max, 10);
  return ta;
}

export const textareaType: FieldType = {
  render(ctx) {
    ensureLabel(ctx.host, ctx.label, ctx.required);
    ensureTextarea(ctx);
    ensureError(ctx.host);
    ensureHelp(ctx.host, ctx.help);
  },

  getValue(ctx) {
    return ctx.host.querySelector<HTMLTextAreaElement>(':scope > textarea')?.value ?? '';
  },

  validate(ctx) {
    const value = String(this.getValue(ctx));
    if (ctx.required) {
      const r = validateRequired(value);
      if (!r.valid) return withCustomMessage(r, ctx);
    }
    const max = ctx.host.getAttribute('maxlength');
    if (max) {
      const r = validateLength(value, undefined, parseInt(max, 10));
      if (!r.valid) return withCustomMessage(r, ctx);
    }
    return { valid: true };
  },

  shouldSubmit() {
    return true;
  },

  setDisabled(ctx, disabled) {
    const ta = ctx.host.querySelector<HTMLTextAreaElement>(':scope > textarea');
    if (ta) ta.disabled = disabled;
  },
};
